import { render } from "./EzerMessages.vue?vue&type=template&id=374d1b98"
import script from "./EzerMessages.vue?vue&type=script&lang=js"
export * from "./EzerMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__